/* 🤖 this file was generated by svg-to-ts */
export const matIconAlignVerticalCenter: {
  name: 'align-vertical-center';
  data: string;
} = {
  name: 'align-vertical-center',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 11h-5V6h-3v5h-4V3H7v8H1.84v2H7v8h3v-8h4v5h3v-5h5z"/></svg>`
};
